import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ISpecificBrickSettingsComponent } from 'src/app/components/dashboard/brick-settings/brick-specific-type-settings/ISpecificBrickSettingsComponent';
import {
   ChangeAgentId,
   ChangeDashboardId,
   ChangeUseBrowserTimezoneAsTargetTimezone,
} from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/grafana-dashboard-viewer-brick-settings/grafana-dashboard-viewer-brick-settings.actions';
import {
   FOLLOW_SELECTED_AGENT,
   GrafanaDashboardViewerSettingsState,
   INDEPENDENT_FROM_SELECTED_AGENT,
} from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/grafana-dashboard-viewer-brick-settings/grafana-dashboard-viewer-brick-settings.state';
import { SamwinAgentListState } from 'src/app/store/samwin/samwin-agent-list/samwin-agent-list.state';
import { AgentListEntryRemoteDto } from 'src/generated/signalR/agent-list-entry-remote-dto';
import { GrafanaDashboardInfoRemoteDto, GrafanaDashboardViewerBrickSettingRemoteDto, GrafanaService } from 'src/generated/swagger';
import _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';

@Component({
   selector: 'samweb-grafana-dashboard-viewer-settings',
   templateUrl: './grafana-dashboard-viewer-settings.component.html',
   styleUrls: ['./grafana-dashboard-viewer-settings.component.scss'],
})
export class GrafanaDashboardViewerSettingsComponent implements OnInit, ISpecificBrickSettingsComponent {
   brickInstanceId: string;

   public dashboardSettings$: Observable<GrafanaDashboardViewerBrickSettingRemoteDto>;
   public availableDashboards$: Observable<Array<GrafanaDashboardInfoRemoteDto>>;
   public availableAgents$: Observable<Array<AgentInfo>>;

   constructor(private store: Store, private grafanaService: GrafanaService, private translateService: TranslateService) {}

   ngOnInit() {
      this.dashboardSettings$ = this.store.select(GrafanaDashboardViewerSettingsState.getDashboardSettingsFn).pipe(map((fn) => fn(this.brickInstanceId)));
      this.availableDashboards$ = this.grafanaService.getAvailableDashboards().pipe(switchMap((response) => of(response.dashboards ?? [])));
      this.availableAgents$ = this.store.select(SamwinAgentListState.getAgentList).pipe(
         switchMap((agentList: AgentListEntryRemoteDto[]) => {
            return of([
               <AgentInfo>{
                  id: FOLLOW_SELECTED_AGENT,
                  name: this.translateService.instant('brick.brick_definitions.grafana_dashboard_viewer.settings.follow_selected_agent'),
               },
               <AgentInfo>{
                  id: INDEPENDENT_FROM_SELECTED_AGENT,
                  name: this.translateService.instant('brick.brick_definitions.grafana_dashboard_viewer.settings.independent_from_selected_agent'),
               },
               ..._(agentList)
                  .map((entry) => <AgentInfo>{ id: entry.userId, name: entry.displayName })
                  .orderBy((a) => a.name.toLowerCase())
                  .value(),
            ]);
         })
      );
   }

   selectedDashboardChanged(dashboardId: number) {
      this.store.dispatch(new ChangeDashboardId(this.brickInstanceId, dashboardId));
   }

   selectedAgentChanged(agentId: number) {
      this.store.dispatch(new ChangeAgentId(this.brickInstanceId, agentId));
   }

   useBrowserTimezoneAsTargetTimezoneChanged(useBrowserTimezoneAsTargetTimezone: boolean) {
      this.store.dispatch(new ChangeUseBrowserTimezoneAsTargetTimezone(this.brickInstanceId, useBrowserTimezoneAsTargetTimezone));
   }
}

class AgentInfo {
   public id: number;
   public name: string;
}
